const escapeCsvValue = (value) => {
  if (value === null || value === undefined) return '';

  const stringValue = String(value);
  const shouldQuote = /[",\n\r;]/.test(stringValue);
  const escaped = stringValue.replace(/"/g, '""');

  return shouldQuote ? `"${escaped}"` : escaped;
};

export const exportCsv = (filename, headers, rows) => {
  const content = [
    headers.map((header) => escapeCsvValue(header.label)).join(';'),
    ...rows.map((row) => headers.map((header) => escapeCsvValue(row[header.key])).join(';')),
  ].join('\n');

  const blob = new Blob([`\uFEFF${content}`], {
    type: 'text/csv;charset=utf-8;',
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
